import script from "./ListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListView.vue?vue&type=script&setup=true&lang=ts"

import "./ListView.vue?vue&type=style&index=0&id=01478d51&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01478d51"]])

export default __exports__